export default "__VITE_ASSET__BJF9ks$y__"